import React, { useState, useEffect, useRef } from "react";
import { I18n, Auth } from "aws-amplify";
import { DmInput, DmButton, DmMessage } from "dm-react-ui";
import { Form, Alert } from "antd";
import { authService } from "../../../services";
import CodeInput from "../../components/CodeInput/CodeInput";
import MfaSelector from "../invites/MfaSelector/MfaSelector";

const Login = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [messageData, setMessageData] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [firstLogingIn, setFirstLogingIn] = useState(false);
  const [loging, setLoging] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const forgotPasswordUrl = {
    dev: "https://us-west-2.dev.getdatacl.edatamart.co/portal-manager/forgot_password",
    qa: "https://us-east-1.qa.getdatacl.edatamart.co/portal-manager/forgot_password",
    homo: "https://homo.services.datamart.cl/portal-manager/forgot_password",
    prod: "https://services.datamart.cl/portal-manager/forgot_password",
  };
  const [credentialsValidated, setCredentialsValidated] = useState(false);
  const [userData, setUserData] = useState(null);
  const [settingMfa, setSettingMfa] = useState(false);

  const hidedSubmitButtonRef = useRef(null);

  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        setErrorMessage(null);
      }, 5000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorMessage]);

  function showMessageInfo() {
    return (
      <DmMessage
        messageText={I18n.get(messageData.mText)}
        descriptionText={I18n.get(messageData.dText)}
        type={messageData.type}
        key={``}
        duration={5}
      />
    );
  }

  async function makePostRequest(url, payload) {
    const response = await fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(payload), // body data type must match "Content-Type" header
    });
    return response.json();
  }

  function setGlobalUserData() {
    Auth.currentAuthenticatedUser().then((authUser) => {
      setLoging(false);
      const userData = {
        username: authUser.username,
        attributes: authUser.attributes,
        userPermissions: JSON.parse(
          authUser.signInUserSession.idToken.payload.user_permissions
        ),
      };
      localStorage.setItem("user-profile", JSON.stringify(userData));
      setLoging(false);
      // eslint-disable-next-line no-undef
      singleSpaNavigate("/");
    });
  }

  const onFirstLogin = (values) => {
    setShowMessage(false);
    setFirstLogingIn(true);
    if (values.email && values.password) {
      authService
        .login(values.email?.toLowerCase(), values.password)
        .then((authUser) => {
          if (
            authUser?.challengeName === "SOFTWARE_TOKEN_MFA" ||
            authUser?.challengeName === "SMS_MFA"
          ) {
            setUserData(authUser);
            setFirstLogingIn(false);
            setCredentialsValidated(true);
          } else if(authUser.attributes?.["custom:no_mfa"] != "true"){            
            Auth.setPreferredMFA(authUser, "SMS")
              .then((data) => {
                setUserData(authUser);
                setSettingMfa(true);
              })
              .catch((err) => {
                setMessageData({
                  type: "error",
                  mText: I18n.get("Error"),
                  dText: I18n.get("Please contact an administrator"),
                });
                setShowMessage(true);
              });
            setUserData(authUser);
            setSettingMfa(true);
          } else {
            console.log("skipMFA", authUser);            
            setGlobalUserData();
          }
        })
        .catch((error) => {
          console.log("error", error);
          switch (error.code) {
            case "PasswordResetRequiredException":
              makePostRequest(forgotPasswordUrl[process.env.PROJECT_STAGE], {
                email: values.email,
                client_id: process.env.AWS_USER_POOL_WEB_CLIENT_ID,
              })
                .then((resp) => {
                  if (!resp?.code === 200) {
                    setMessageData({
                      type: "error",
                      mText: "Error",
                      dText: "Consulte con su administrador",
                    });
                    setIsButtonDisabled(true);
                    setShowMessage(true);
                  } else if (resp?.code === 200) {
                    console.log("reset password user response", resp);
                    setMessageData({
                      type: "error",
                      mText: "Activa tu cuenta para poder ingresar",
                      dText:
                        "Revisa tu bandeja de entrada y busca el correo de activación",
                    });
                    setIsButtonDisabled(true);
                    setShowMessage(true);
                  } else {
                    console.log("reset password user response", resp);
                    if (resp.error === "Users does not exist.") {
                      setMessageData({
                        type: "error",
                        mText: "Error",
                        dText: "El usuario no existe.",
                      });
                    } else {
                      setMessageData({
                        type: "error",
                        mText: "Error",
                        dText: "Consulte con su administrador",
                      });
                    }
                    setIsButtonDisabled(true);
                    setShowMessage(true);
                  }
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
              setShowMessage(false);
              break;
            case "UserNotConfirmedException":
              setErrorMessage(I18n.get("Su cuenta no ha sido confirmada."));
              break;
            case "UsernameExistsException":
              break;
            case "UserNotFoundException":
              setErrorMessage(I18n.get("Usuario no registrado."));
              break;
            case "NotAuthorizedException":
              if (error.message === "User is disabled.") {
                setErrorMessage(I18n.get("El usuario está deshabilitado"));
                break;
              } else {
                setErrorMessage(I18n.get("Credenciales incorrectas."));
                break;
              }
          }
        })
        .finally(() => setFirstLogingIn(false));
    }
  };

  function onConfirmLogin(values) {
    setLoging(true);
    authService
      .confirmLogin(userData, values.code, userData.challengeName)
      .then((authUser) => {
        setGlobalUserData();
      })
      .catch((error) => {
        console.log("error", error);
        switch (error.code) {
          case "ExpiredCodeException":
            setErrorMessage(I18n.get("El código ha expirado."));
            break;
          case "CodeMismatchException":
            setErrorMessage(
              I18n.get("Looks like this code isn't right. Please try again.")
            );
            break;
          case "NotAuthorizedException":
            setErrorMessage(I18n.get("Credenciales incorrectas."));
            break;
          case "UserNotConfirmedException":
            setErrorMessage(I18n.get("Su cuenta no ha sido confirmada."));
            break;
          case "UserNotFoundException":
            setErrorMessage(I18n.get("Usuario no registrado."));
            break;
          case "UsernameExistsException":
            setErrorMessage(I18n.get("El usuario ya existe."));
            break;
          default:
            setErrorMessage(I18n.get("Error"));
        }
        setLoging(false);
      });
  }

  const submitHidenButton = (
    <button
      type="submit"
      style={{ display: "none" }}
      ref={hidedSubmitButtonRef}>
      Submit
    </button>
  );

  return settingMfa ? (
    <MfaSelector user={userData} />
  ) : (
    <div>
      <div style={{ marginBottom: 30 }}>
        <h1 className="dm-portal-login-h1" style={{ margin: "15px 0 0 0" }}>
          {I18n.get("Bienvenido")}
        </h1>
        <h3 style={{ marginTop: "-15px" }} className="dm-portal-login-h3">
          {I18n.get("a tu central de datos")}
        </h3>
      </div>
      {credentialsValidated ? (
        <div>
          <div style={{ fontSize: 12, marginBottom: 16, maxWidth: 230 }}>
            {userData?.challengeName === "SMS_MFA" ? (
              <>
                <span>
                  {I18n.get(
                    `Ingresa el código de confirmación que te hemos enviado al teléfono `
                  )}
                </span>
                <span
                  style={{
                    fontWeight: "700",
                  }}>
                  {userData?.challengeParam.CODE_DELIVERY_DESTINATION}
                </span>
              </>
            ) : (
              <span>
                {I18n.get(
                  `Ingresa el código de seis dígitos de tu aplicación de autenticación`
                )}
              </span>
            )}
          </div>
          <CodeInput
            onSubmit={(code) => onConfirmLogin({ code })}
            submitButton={submitHidenButton}
            onWrongCodeInput={() => setErrorMessage(null)}
          />
          <div style={{ height: "18px", paddingTop: "6px" }}>
            {errorMessage && (
              <Alert
                style={{
                  maxWidth: 250,
                  padding: "0px",
                  border: "none",
                  background: "transparent",
                }}
                className="dm-portal-login-alert-message"
                message={errorMessage}
                type="error"
              />
            )}
          </div>
          <DmButton
            type="primary"
            style={{ width: 158, marginTop: 32 }}
            loading={loging || firstLogingIn}
            disabled={isButtonDisabled || loging}
            onClick={() => hidedSubmitButtonRef.current.click()}
            size="large">
            {I18n.get("Iniciar sesión")}
          </DmButton>
        </div>
      ) : (
        <Form
          id="dm-portal-login-form"
          style={{ maxWidth: 250 }}
          name="basic"
          initialValues={{ remember: true }}
          onFinish={!credentialsValidated ? onFirstLogin : onConfirmLogin}>
          <Form.Item
            name="email"
            rules={[
              {
                type: "email",
                message: I18n.get("Correo electrónico inválido"),
              },
              {
                required: true,
                message: I18n.get("Correo electrónico requerido"),
              },
            ]}>
            <DmInput
              style={{ maxWidth: 220 }}
              placeholder={I18n.get("Correo electrónico")}
            />
          </Form.Item>
          <Form.Item
            name="password"
            style={{ marginBottom: "0px" }}
            rules={[
              {
                required: true,
                message: I18n.get("Contraseña requerida"),
              },
            ]}>
            <DmInput
              style={{ maxWidth: 220 }}
              placeholder={I18n.get("Contraseña")}
              type="password"
            />
          </Form.Item>
          <div style={{ height: "38px", paddingTop: "12px" }}>
            {errorMessage && (
              <Alert
                style={{
                  maxWidth: 250,
                  padding: "0px",
                  border: "none",
                  background: "transparent",
                }}
                className="dm-portal-login-alert-message"
                message={errorMessage}
                type="error"
              />
            )}
          </div>
          <Form.Item>
            <DmButton
              type="primary"
              htmlType="submit"
              style={{ width: 158 }}
              loading={loging || firstLogingIn}
              disabled={isButtonDisabled || loging}
              size="large">
              {!credentialsValidated
                ? I18n.get("Siguiente")
                : I18n.get("Iniciar sesión")}
            </DmButton>
          </Form.Item>
        </Form>
      )}
      {!credentialsValidated && (
        <a href={`/auth/forgot`} className="dm-portal-login-forgot-link">
          {I18n.get("Olvidé mi contraseña")}
        </a>
      )}
      {showMessage && showMessageInfo()}
    </div>
  );
};

export default Login;
